import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-tester',
  templateUrl: './menu-tester.component.html',
  styleUrls: ['./menu-tester.component.scss']
})
export class MenuTesterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
